/* --------------------------------------------------------------------------------------
   xwAlert.directive.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved. 
   
   Copyright protection claimed includes all forms and matters of copyrightable material 
   and information now allowed by statutory or judicial law or hereinafter granted, 
   including without limitation, material generated from the software programs which 
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

/*eslint semi: ["error", "never"]*/
 export class xwAlert {
  /*@ngInject*/
  constructor () {
    this.restrict = 'A'
    this.scope = {
      onClose: '&'
    }
  }
  link(scope, elem, attrs) {
    let options = {
        buttons: [],
        close: () => scope.onClose()
    }

    elem.first().xrxalert(options)
    //listen to attribute change to open/close
    attrs.$observe('display', (val) => {
      if (val == 'true')
        elem.first().xrxalert('open')
      else
        elem.first().xrxalert('close')
    });

    scope.$on('$destroy', () => {
      scope = null
    })
    elem.on('$destroy', () => {
      elem.first().xrxalert('destroy')
      elem = null
    })
  }
  static directiveFactory() {
    xwAlert.instance = new xwAlert()
    return xwAlert.instance
  }
}



// WEBPACK FOOTER //
// ./src/app/xrxWrappers/xwAlert.directive.js